/*
 * Header — scroll shadow + mobile burger menu.
 *
 * Особенности:
 *   - тень/border на .site-header появляется после 10px скролла;
 *   - бургер синхронизирован с панелью через aria-expanded / data-open;
 *   - Escape закрывает меню, фокус возвращается на бургер;
 *   - скролл body блокируется классом .has-menu-open;
 *   - smooth-scroll для якорных ссылок (#form, #services и т.д.);
 *   - при переходе с мобилы на десктоп (≥1024px) меню закрывается.
 */

const SCROLL_THRESHOLD = 10;
const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const burger = header.querySelector('.site-header__burger');
  const menu = document.getElementById(burger?.getAttribute('aria-controls') ?? '');

  // ─── Scroll shadow ──────────────────────────────────────────────
  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // ─── Mobile menu ────────────────────────────────────────────────
  if (burger && menu) {
    const openMenu = () => {
      burger.setAttribute('aria-expanded', 'true');
      menu.dataset.open = 'true';
      document.body.classList.add('has-menu-open');
    };

    const closeMenu = ({ restoreFocus = false } = {}) => {
      burger.setAttribute('aria-expanded', 'false');
      menu.dataset.open = 'false';
      document.body.classList.remove('has-menu-open');
      if (restoreFocus) burger.focus();
    };

    burger.addEventListener('click', () => {
      const isOpen = burger.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeMenu();
      else openMenu();
    });

    // Закрыть меню при клике по ссылке внутри него
    menu.addEventListener('click', (e) => {
      if (e.target instanceof HTMLAnchorElement) closeMenu();
    });

    // Escape закрывает меню и возвращает фокус
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      closeMenu({ restoreFocus: true });
    });

    // При переходе на десктоп схлопываем mobile-меню
    const onMqChange = (e) => {
      if (e.matches) closeMenu();
    };
    if (DESKTOP_MQ.addEventListener) DESKTOP_MQ.addEventListener('change', onMqChange);
    else DESKTOP_MQ.addListener(onMqChange); // fallback для Safari <14
  }

  // ─── Smooth scroll for in-page anchors ──────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}
